import { Component } from '@angular/core';
import { ParcelItemTypesComponent } from '../../../settings/account-settings-drawer/parcel-item-types/parcel-item-types.component';

@Component({
  selector: 'tenant-parcel-item-types-section',
  standalone: true,
  imports: [ParcelItemTypesComponent],
  template: `
    <div class="settings-section">
      <div class="settings-section-header">
        <h2 class="settings-section-title">Parcel Item Types</h2>
        <p class="settings-section-description">
          Manage parcel categories and item types for your parcel operations
        </p>
      </div>
      <div class="settings-section-content">
        <tenant-parcel-item-types></tenant-parcel-item-types>
      </div>
    </div>
  `,
  styles: [
    `
    .settings-section {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .settings-section-header {
      border-bottom: 1px solid var(--sidebar-border);
      padding-bottom: 16px;
    }

    .settings-section-title {
      font-size: 20px;
      font-weight: 600;
      color: var(--header-text);
      margin: 0 0 4px 0;
    }

    .settings-section-description {
      font-size: 14px;
      color: var(--header-text-secondary);
      margin: 0;
    }

    .settings-section-content {
      /* Content styles handled by child component */
    }
  `,
  ],
})
export class ParcelItemTypesSectionComponent {}
